/**
 * snapshotsReducer.js
 * Created by zl952fc on 11/17/2020.
 */
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function snapshotsReducer(state = initialstate.snapshots, action) {
	switch (action.type) {
		case types.GET_SNAPSHOTS:
			return action.response || state;
		default:
			return state;
	}
}
